module.exports = __webpack_public_path__ + "img/user-krogec-white.fc073c75.svg";